module.exports = __webpack_public_path__ + "314210a4825a7cc8ca7db893dfd9d283.woff2";